'use strict';
(function () {
    App.controller('LifeEditCtrl', LifeEditCtrl);

    LifeEditCtrl.$inject = ['$scope', '$state', '$stateParams', '$filter', '$q', '$mdDialog', 'Config', 'lifeInsuranceService', 'packageService', 'statesService', '$timeout', 'lifeInsuranceSharedService', 'popUpService'];

    function LifeEditCtrl($scope, $state, $stateParams, $filter, $q, $mdDialog, Config, lifeInsuranceService, packageService, statesService, $timeout, lifeInsuranceSharedService, popUpService) {

        if (true) {
            $state.go('root.life.start');
            return;
        }

        var userObject = window.sessionStorage.getItem('userObject');
        if (userObject) {
            $scope.currentUser = angular.fromJson(userObject);
        } else {
            $state.go('root.life.list');
            return;
        }

        $scope.isAddressReady = true;

        function triggerAddressReady() {
            $scope.isAddressReady = false;

            $timeout(function () {
                $scope.isAddressReady = true;
            });
        }

        $scope.link = 'root.life.list';
        $scope.$emit('link', $scope.link);

        $scope.declarationEntity = $stateParams.declarationEntity;

        $scope.addressToApply = $scope.currentUser.person.address;

        var availablePersonsTypes = [{
            "type": "USER",
            "name": "Ubezpieczony pracownik",
        },
            {
                "type": "PARTNER",
                "name": "Współmałżonek lub partner",
            },
            {
                "type": "CHILD",
                "name": "Pełnoletnie dziecko",
            }
        ];

        $scope.isLifePackageHidden = function (person, group, item) {
            return $scope.currentPersonType !== 'USER' &&  $scope.lifePackages[group].disabledForFamilyMembers;
        };

        $scope.personsTypesList = availablePersonsTypes;

        var allPersonTypes = angular.copy(availablePersonsTypes);
        allPersonTypes.push({
            "type": "SPOUSE",
            "name": "Współmałżonek lub partner",
        });
        allPersonTypes.push({
            "type": "USER",
            "name": "Ubezpieczony pracownik",
        });

        var availablePersons = angular.copy(availablePersonsTypes).map(function (personType) {
            personType.person = {
                citizenshipType: "POLISH",
                gender: "FEMALE"
            };
            personType.partner = {
                citizenshipType: 'POLISH',
                gender: "FEMALE"
            };
            personType.assured = [{
                type: 'PERSON',
                country: 'POLISH',
                personBirthdate: null,
                sameAddress: true
            }];
            return personType;
        });

        $scope.cans = {canUserAddPartnerToSelf: false, canAddPartner: false, canAddSpouse: false};


        $scope.declarations = null;
        (function () {
            lifeInsuranceService.getGroupedDeclarations("ALL")
                .then(function (success) {
                    var declarations = success.data.list;

                    var flatten = [];
                    declarations.forEach(function (declarationGroup) {
                        declarationGroup.declarations.sort(function (a, b) {
                           return new Date(b.declaration.creationTime) - new Date(a.declaration.creationTime);
                        });
                        flatten = flatten.concat(declarationGroup.declarations);
                    });
                    $scope.cans = lifeInsuranceSharedService.canAddPartnerOrSpouse(flatten, $scope.currentMode, $scope.currentPerson, availablePersons, $scope.currentPersonType, $scope.personsTypesList);
                    $scope.declarations = declarations;
                    console.log('$scope.declarations', $scope.declarations);
                    getWorkerAddressFromLastUserDeclaration();
                }, function (error) {
                    console.error(error);
                });
        })();



        function getWorkerAddressFromLastUserDeclaration() {
            var userDeclarationsGroups = $scope.declarations.filter(function (group) {
                return group.type === 'USER' && group.declarations.length;
            });
            console.log('userDeclarationsGroups', userDeclarationsGroups);
            if (userDeclarationsGroups.length) {
                var userDeclarationsGroup = angular.copy(userDeclarationsGroups).shift();
                var userLastDeclaration = userDeclarationsGroup.declarations.shift();
                $scope.addressToApply = userLastDeclaration.revision.person.address;
                console.log('$scope.addressToApply from userLastDeclaration');
            }
            console.log('$scope.addressToApply', $scope.addressToApply);
            triggerAddressReady();
        }


        var _currentPerson = {};
        if ($scope.declarationEntity && $stateParams.person) {
            _currentPerson.person = $scope.declarationEntity['revision'].person;
            _currentPerson.assured = $scope.declarationEntity['assured'];
            _currentPerson.partner = $scope.declarationEntity['revision'].partner;
            _currentPerson.branch = $scope.declarationEntity['revision'].branch;
            _currentPerson.type = $stateParams.person.type;
            _currentPerson.person.type = _currentPerson.type;
            _currentPerson.person.employmentDate = $scope.declarationEntity.revision.employmentDate;
            _currentPerson.person.formOfEmployment = $scope.declarationEntity.revision.formOfEmployment;
            _currentPerson.person.otherFormOfEmployment = $scope.declarationEntity.revision.otherFormOfEmployment;
        } else if ($stateParams.person) {
            _currentPerson.person = $stateParams.person;
            _currentPerson.branch = $scope.currentUser.branch;
            _currentPerson.type = $stateParams.person.type;
            _currentPerson.person.type = _currentPerson.type;
        } else {
            _currentPerson = null;
        }

        if (!_currentPerson) {
            $scope.personsTypes = angular.copy(availablePersonsTypes);
            $scope.currentPersonType = $scope.personsTypes[0].type;
            _currentPerson = angular.copy(availablePersons[0]);
            _currentPerson = $scope.currentUser;
            _currentPerson.assured = [{
                type: 'PERSON',
                country: 'POLISH',
                personBirthdate: null,
                sameAddress: true,
                city: $scope.currentUser.person.address.city,
                street: $scope.currentUser.person.address.street,
                number: $scope.currentUser.person.address.number,
                apartment: $scope.currentUser.person.address.apartment,
                zipCode: $scope.currentUser.person.address.zipCode
            }];
            _currentPerson.type = $scope.currentPersonType;
        } else {
            if (!_currentPerson.type) {
                $scope.currentPersonType = availablePersonsTypes[0].type;
            } else {
                angular.forEach(allPersonTypes, function (personType) {
                    if (personType.type === _currentPerson.type) {
                        $scope.currentPersonType = personType.type;
                    }
                });
            }

            if (!_currentPerson.partner) {
                _currentPerson.isPartner = false;
                _currentPerson.partner = {
                    citizenshipType: 'POLISH',
                    gender: "FEMALE"
                };
            } else {
                _currentPerson.isPartner = true;
            }

            if (!_currentPerson.assured.length) {
                _currentPerson.isAssured = false;
                _currentPerson.assured = [{
                    type: 'PERSON',
                    country: 'POLISH',
                    personBirthdate: null,
                    sameAddress: true
                }];
            } else {
                _currentPerson.isAssured = true;
            }


        }
        if (typeof _currentPerson.partner === 'undefined' && typeof _currentPerson.isPartner === "undefined") {
            _currentPerson.partner = {
                citizenshipType: 'POLISH',
                gender: "FEMALE"
            };
        }

        $scope.currentPerson = _currentPerson;


        $scope.page = 'zoch_life_insurance';
        $scope.$emit('page', $scope.page);

        var packageToGroupName = {};

        packageService.dataLifeList().then(function (data) {
            $scope.lifePackages = data.data.group;

            (function () {
                angular.forEach($scope.lifePackages, function (group, groupKey) {
                    angular.forEach(group.item, function (single) {
                        if ($scope.declarationEntity) {
                            var packageId = $scope.declarationEntity['revision']['lifeInsurance'].id;
                            if (single.id === packageId) {
                                $scope.choose = [packageId];
                            }
                        }
                        packageToGroupName[single.id] = group.code;
                    })
                });
            })();
        });

        $scope.choose = [];

        $scope.persons = [{}];

        $scope.prices = [{}, {}, {}];

        var availableModes = [{
            name: "Nowa deklaracja",
            id: 'NEW'
        },
            {
                name: "Zmiana wariantu",
                id: 'CHANGE'
            },
        ];


        if ($stateParams.person) {
            $scope.step = 'Edycja deklaracji';
            $scope.currentMode = availableModes[1].id;
        } else {
            $scope.step = 'Dodawanie deklaracji';
            $scope.currentMode = availableModes[0].id;
        }
        $scope.$emit('step', $scope.step);

        function PopUpInfoCtrl($scope, $mdDialog, locals, config) {
                    $scope.locals = locals;
                    $scope.config = config;

                    $scope.hide = function () {
                        $mdDialog.hide();
                    };

                    $scope.cancel = function () {
                        $mdDialog.cancel();
                    };

                    $scope.confirm = function () {
                        $mdDialog.hide($scope.locals);
                    };
        }
        PopUpInfoCtrl.$inject = ['$scope', '$mdDialog', 'locals', 'config'];

        $scope.showPopUp = function (ev, head, content, text, target, exitOrReload, config) {
            $mdDialog.show({
                controller: PopUpInfoCtrl,
                templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    head: head,
                    content: content,
                    button: {
                        text: text,
                        target: target
                    }
                }
            }).then(function (data) {
                if (!!config && !!config.confirmCallback) {
                    config.confirmCallback(data);
                }
            }, function (data) {
                if (!!config && !!config.cancelCallback) {
                    config.cancelCallback(data);
                }
            });
        };

        var cityListsPromise = function (query) {
            var deferred = $q.defer();

            statesService.dataCityLists({
                name: query
            }).then(function (data) {
                deferred.resolve(data.data);
            });

            return deferred.promise;
        };

        $scope.querySearchLocalization = function (query) {
            if (!query) {
                return;
            }
            return cityListsPromise(query).then(function (results) {
                return results;
            });
        };

        $scope.pesel = null;
        $scope.readByPeselForm = {};

        $scope.alreadyHasDeclaration = null;
        $scope.originalCopyEntered = false;


        $scope.changeCurrentPerson = function (currentPersonType) {
            $scope.currentPersonType = currentPersonType;
            angular.forEach(availablePersons, function (person) {
                if (person.type === currentPersonType) {
                    $scope.currentPerson = person;
                }
            });
            $scope.currentPerson.branch = $scope.currentUser.branch;
            triggerAddressReady();
        };

        $scope.save = function () {
            var vm = this;

            var el = $(vm.form.$$element[0]).find('button[type="submit"]');

            if (typeof $scope.choose[0] === "undefined") {
                $scope.showPopUp('', 'Dokonaj wyboru przy wariantach', 'Aby przejść dalej zaznacz minimum jeden wariant dla pracownika.');
                return 0;
            }

            if (!vm.form.$valid) {
                // $scope.showPopUp('', 'Uzupełnij pola', 'Aby dokończyć rejestrację wypełnij wszystkie wymagane pola.', '');
                // document.body.scrollTop = document.documentElement.scrollTop = 80;
                return 0;
            }

            var isPercentageValid = $filter('percentageOfBenefit')($scope.currentPerson.isAssured ? $scope.currentPerson.assured : []);
            if (!isPercentageValid) {
                $scope.showPopUp('', 'Nieprawidłowy procent świadczegnia', 'Procent świadczenia dla wszystkich uposażonych musi się sumować do 100%');
                return;
            }

            if ($scope.currentPerson.type === 'USER') {
                if (!validateInsuredAge($scope.currentPerson.person)) {
                    return;
                }
            } else {
                if (!validateCoinsuredAge($scope.currentPerson.person)) {
                    return;
                }
            }

            var isChange = $scope.currentMode === 'CHANGE';
            if (isChange) {
                save(isChange, el);
            } else {
                lifeInsuranceService.hasDeclarationByTypeAndIdentifier(packageToGroupName[$scope.choose[0]], $scope.currentPerson.person.identifier).then(function (success) {
                    if (success.data.result) {
                        changeExistingDeclarationPromise().then(function (success) {
                            isChange = true;
                            save(isChange, el);
                        }, function (err) {
                            isChange = false;
                            save(isChange, el);
                        });
                    } else {
                        save(isChange, el);
                    }

                }, function (error) {

                });
            }
        };

        function changeExistingDeclarationPromise() {
            var defer = $q.defer();
            var config = {
                cancelButton: "Nie",
                cancelCallback: function (data) {
                    defer.reject(data);
                },
                confirmCallback: function (data) {
                    defer.resolve(data);
                },
            };

            $scope.showPopUp('', 'Deklaracja już istnieje', 'Podobna deklaracja już istnieje. Czy chcesz nadpisać istniejącą?', 'Tak', null, true, config);

            return defer.promise;
        }

        function save(isChange, el) {
            if (el.hasClass('disabled')) {
                return 0;
            } else {
                el.addClass('disabled');
            }

            $scope.currentPerson.agreements = {
                sameAsFirst: false
            }

            var toSave = $filter('preparePersonsData')(angular.extend({}, $scope.currentPerson, {
                persons: [$scope.currentPerson],
                choose: [$scope.choose],
            }), $scope.currentPerson.branch.id);

            angular.forEach(toSave.declarations, function (declaration) {
                declaration.isChange = isChange;
                declaration.proposedDate = $filter('proposedDate')('life');
                declaration.id = $scope.declarationEntity ? $scope.declarationEntity.declaration.id : null;
            });

            toSave.userId = $scope.currentUser.userId;

            lifeInsuranceService.saveDeclarations(toSave).then(function (success) {
                $state.go('root.life.list', toSave);
            }, function (error) {
                if (error.data.message === 'MustHaveFamilyOrProtectionDeclarationException') {
                    $scope.showPopUp('', 'Wystąpił błąd', 'Wariant PLUS można dokupić, gdy wybierze się co najmniej jeden z podstawowych wariantów Rodzina lub Ochrona');
                } else {
                    popUpService.showPopUpWithError(error.data, {head: 'Wystąpił błąd', content: 'Nie udało się zapisać deklaracji, prosimy spróbować ponownie później.'});
                }

                $timeout(function () {
                    el.removeClass('disabled');
                }, 1500);
            });
        }


        $scope.addAssured = function () {
            if ($scope.currentPerson['assured'].length < 4) {
                $scope.currentPerson['assured'].push({
                    type: 'PERSON',
                    country: 'POLISH',
                    personBirthdate: null,
                    sameAddress: true
                });
            }
        };

        $scope.deleteAssured = function (obj) {
            $scope.currentPerson['assured'].splice(obj, 1);
        };

        $scope.isShowAllDeclarations = false;
        $scope.showAllDeclarations = function (e) {
            e.stopPropagation();
            $scope.isShowAllDeclarations = true;
        };
        $scope.hideAllDeclarations = function () {
            $scope.isShowAllDeclarations = false;
        };

        $scope.agreements = {};
        $scope.agreements.all = [{
            id: 0,
            content: '<span>Chcę przystąpić do Klubu na warunkach określonych w Regulaminie Klubu. Zapoznałam/em się z jego treścią i akceptuję go.</span>&nbsp;<span class="required">*</span>',
            accepted: false,
            required: true
        },
            {
                id: 1,
                content: '<span>Chcę zostać objęta/y ochroną ubezpieczeniową z sumą ubezpieczenia i na warunkach określonych w umowie, które zostały mi doręczone przed przystąpieniem do ubezpieczenia.</span></span>&nbsp;<span class="required">*</span>',
                accepted: false,
                required: true
            },
            {
                id: 2,
                content: '<span>Zgadzam się* na założenie przez PZU Życie SA dedykowanego konta elektronicznego (trwały nośnik), na które mogę otrzymywać dokumenty ubezpieczenia, powiadomienia, wnioski i oświadczenia oraz poprzez które mogę zawierać lub przystępować do innych umów ubezpieczenia. Zapoznałam/em się z Regulaminem świadczenia usług drogą elektroniczną i akceptuję jego treść. Zgadzam się na otrzymywanie powiadomień o zmianach zawartości konta za pośrednictwem środków komunikacji elektronicznej (w tym wiadomości sms lub e-mail).',
                accepted: false,
                required: false
            },
            {
                id: 3,
                content: '<span>W razie wystąpienia zdarzenia upoważniam kierownictwo wszystkich placówek służby zdrowia i lekarzy do udzielania PZU Życie SA informacji o moim stanie zdrowia i stanie zdrowia moich małoletnich dzieci, w tym obejmujących: przyczyny hospitalizacji i leczenia ambulatoryjnego, wyniki badań diagnostycznych (z wyłączeniem badań genetycznych), przeprowadzonych konsultacji, wyniki leczenia i rokowań, a także do przekazania kopii mojej dokumentacji medycznej i dokumentacji medycznej moich małoletnich dzieci. Upoważnienie to jest potrzebne, aby ustalić odpowiedzialność zakładu ubezpieczeń z tytułu zdarzeń objętych ubezpieczeniem i wysokość świadczenia lub przyczynę śmierci. W razie wystąpienia zdarzenia upoważniam Narodowy Fundusz Zdrowia do przekazania do PZU Życie SA nazw i adresów świadczeniodawców, którzy udzielili mi lub moim małoletnim dzieciom świadczeń opieki zdrowotnej. Upoważnienie to jest potrzebne, aby ustalić odpowiedzialność PZU Życie SA oraz wysokość świadczenia. Powyższe upoważnienia obejmują przekazanie informacji lub dokumentacji medycznej również po mojej śmierci lub po śmierci moich małoletnich dzieci.</span></span>&nbsp;<span class="required">*</span>',
                accepted: false,
                required: true
            },
            {
                id: 4,
                content: '<span>Zgadzam się na udostępnienie moich danych osobowych i ich dalsze przetwarzanie przez świadczeniodawcę PZU Zdrowie SA, oraz dalsze przekazanie tych danych własnym lub współpracującym placówkom medycznym w celu podjęcia wszelkich działań związanych z organizacją i realizacją świadczeń wynikających z wybranego przeze mnie zakresu świadczeń zdrowotnych.</span>&nbsp;<span class="required">*</span>',
                accepted: false,
                required: true
            },
            {
                id: 5,
                content: '<span>W dniu podpisania deklaracji przystąpienia nie przebywam na zwolnieniu lekarskim, w szpitalu, hospicjum, placówce dla przewlekle chorych, na świadczeniu rehabilitacyjnym oraz nie uznano w stosunku do mnie niezdolności do pracy lub niezdolności do służby orzeczeniem właściwego organu (nie stosuje się w grupowym ubezpieczeniu PZU W RAZIE WYPADKU).</span>&nbsp;<span class="required">*</span>',
                accepted: false,
                required: true
            },
            {
                id: 6,
                content: '<span>Dodatkowe oświadczenie dotyczące zdrowia, składane wyłącznie przez MAŁŻONKA, PARTNERA ŻYCIOWEGO i PEŁNOLETNIE DZIECKO, przystępujących do grupowego ubezpieczenia typ P Plus o kodzie PTGP34 oraz ubezpieczeń dodatkowych, którzy bezpośrednio przed przystąpieniem do ubezpieczenia albo nie byli objęci innym ubezpieczeniem grupowym na życie w PZU Życie SA, albo byli objęci takim ubezpieczeniem krócej niż 12 miesięcy.</span>&nbsp;<span class="required">*</span>',
                accepted: false,
                required: true
            },
            {
                id: 7,
                content: '<span>Wyrażam zgodę na przetwarzanie przez PZU Życie SA moich danych osobowych dotyczących stanu zdrowia zawartych w deklaracji przystąpienia do ubezpieczenia – w celu przystąpienia oraz wykonywania umowy ubezpieczenia, a także przekazanych PZU Życie SA przez placówki służby zdrowia, lekarzy lub przeze mnie w trakcie obowiązywania umowy ubezpieczenia – w celu wykonania umowy ubezpieczenia. Zgoda jest dobrowolna, ale konieczna w celu realizacji umowy.</span>&nbsp;<span class="required">*</span>',
                accepted: false,
                required: true
            },
            {
                id: 8,
                content: '<span>Wyrażam zgodę na udostępnienie przez PZU Życie SA moich danych osobowych podmiotom z grupy PZU, tj. PZU SA, PTE PZU SA, TFI PZU SA, PZU Pomoc SA, PZU Zdrowie SA, PZU CO SA, Link4 TU SA, PEKAO SA, Alior Bank SA, w ich własnych celach marketingowych, obejmujących profilowanie zmierzające do określenia preferencji lub potrzeb w zakresie produktów ubezpieczeniowych i innych produktów finansowych oraz przedstawienia odpowiedniej oferty.</span>',
                accepted: false,
                required: false
            },
            {
                id: 9,
                content: '<span>Wyrażam zgodę na otrzymywanie od PZU SA, PZU Życie SA, PTE PZU SA, TFI PZU SA, PZU Zdrowie SA, PZU CO SA, Link4 TU SA, PEKAO SA, Alior Bank SA informacji marketingowych za pośrednictwem środków komunikacji elektronicznej (e-mail, SMS/MMS).</span>',
                accepted: false,
                required: false
            },
            {
                id: 10,
                content: '<span>Wyrażam zgodę na otrzymywanie od PZU Pomoc SA, oraz jej partnerów handlowych informacji marketingowych za pośrednictwem środków komunikacji elektronicznej (e-mail, SMS/MMS).</span>',
                accepted: false,
                required: false
            },
            {
                id: 11,
                content: '<span>Wyrażam zgodę na otrzymywanie od PZU SA, PZU Życie SA, PTE PZU SA, TFI PZU SA, PZU Zdrowie SA, PZU CO SA, Link4 TU SA, PEKAO SA, Alior Bank SA informacji marketingowych za pośrednictwem połączeń głosowych (rozmowa telefoniczna, komunikaty głosowe IVR).</span>',
                accepted: false,
                required: false
            },
            {
                id: 12,
                content: '<span>Wyrażam zgodę na otrzymywanie od PZU Pomoc SA i jej partnerów handlowych informacji marketingowych za pośrednictwem połączeń głosowych (rozmowa telefoniczna, komunikaty głosowe IVR).</span>',
                accepted: false,
                required: false
            },
            {
                id: 13,
                content: '<span>Wyrażam zgodę na przetwarzanie moich danych osobowych przez PZU Życie SA w celu przekazywania mi treści marketingowych dotyczących produktów ubezpieczeniowych i innych produktów finansowych, kiedy nie będę posiadać ubezpieczenia w tej firmie.</span>',
                accepted: false,
                required: false
            },
            {
                id: 14,
                content: '<span>Wyrażam zgodę na przesyłanie informacji, które mają związek z moim ubezpieczeniem w PZU Życie SA za pośrednictwem środków komunikacji elektronicznej, w tym wiadomości SMS/MMS lub e-mail, na wskazany przeze mnie numer telefonu lub adres mailowy. W razie zmiany podanych przeze mnie danych kontaktowych, zobowiązuję się uaktualniać moje dane, dzięki którym będę otrzymywać informacje za pośrednictwem środków komunikacji elektronicznej.</span>',
                accepted: false,
                required: false
            },
            {
                id: 15,
                content: '<span>Oświadczam, że zapoznałam/em się z informacją o przetwarzaniu moich danych osobowych, zawartą w dostarczonym mi dokumencie Informacja Administratora danych osobowych (PZU Życie SA).</span>',
                accepted: false,
                required: false
            },
            {
                id: 16,
                content: '<span>Oświadczam, że zapoznałam/em się z informacją o przetwarzaniu moich danych osobowych, zawartą w dostarczonym mi dokumencie Informacja Administratora danych osobowych (PZU Pomoc SA).</span>',
                accepted: false,
                required: false
            },
        ];

        $scope.agreements.requiredAgreements = $scope.agreements.all.filter(function (single) {
            return single.required;
        });
        $scope.agreements.optionalAgreements = $scope.agreements.all.filter(function (single) {
            return !single.required;
        });

        /**
         * Check if a person complies with the age restrictions;
         *
         * @param person
         * @returns {*} boolean
         */
        function validateInsuredAge(person) {
            if (person.citizenshipType === 'POLISH') {
                if ($filter('isOver75FromIdentifier')(person.identifier)) {
                    $scope.showPopUp('', 'Informacja', 'Do ubezpieczenia mogą przystąpić osoby, które nie ukończyły 75 lat.', 'Wróć do strony głównej', 'root.dashboard', true);
                    return 0;
                }

            } else {
                if ($filter('isOver75FromBirthdate')(new Date(person.birthdate))) {
                    $scope.showPopUp('', 'Informacja', 'Do ubezpieczenia mogą przystąpić osoby, które nie ukończyły 75 lat.', 'Wróć do strony głównej', 'root.dashboard', true);
                    return 0;
                }
            }
            return true;
        }

        /**
         * Check if a person complies with the age restrictions;
         *
         * @param person
         * @returns {*} boolean
         */
        function validateCoinsuredAge(person) {
            if (person.citizenshipType === 'POLISH') {
                if ($filter('isNoAdultFromIdentifier')(person.identifier)) {
                    $scope.showPopUp('', 'Do ubezpieczenia mogą przystąpić tylko osoby pełnoletnie', '');
                    return false;
                }
                if ($filter('isOver75FromIdentifier')(person.identifier)) {
                    $scope.showPopUp('', 'Do ubezpieczenia mogą przystąpić osoby, które nie ukończyły 75 lat.', '');
                    return false;
                }
            } else {
                if ($filter('isNoAdultFromBirthdate')(new Date(person.birthdate))) {
                    $scope.showPopUp('', 'Do ubezpieczenia mogą przystąpić tylko osoby pełnoletnie', '');
                    return false;
                }
                if ($filter('isOver75FromBirthdate')(new Date(person.birthdate))) {
                    $scope.showPopUp('', 'Do ubezpieczenia mogą przystąpić osoby, które nie ukończyły 75 lat.', '');
                    return false;
                }
            }
            return true;
        }

        $scope.$watch('currentPersonType', function (oldVal, newVal) {
            if (oldVal !== newVal) {
                console.log($scope.currentPersonType);
                if ($scope.currentPersonType === 'USER') {
                    _currentPerson = $scope.currentUser;
                    _currentPerson.type = $scope.currentPersonType;
                    $scope.currentPerson = _currentPerson;
                    triggerAddressReady();
                }
            }
        }, true);

        $scope.assuredTypeChanged = function (currentAssured) {
            if (currentAssured.type === 'ORGANIZATION') {
                currentAssured.city = '';
                currentAssured.street = '';
                currentAssured.number = '';
                currentAssured.apartment = '';
                currentAssured.zipCode = '';
            }
        };

        $scope.$watch('currentPerson', function (oldVal, newVal) {
            for (var a = 0; a < $scope.currentPerson.assured.length; a++) {

                var currentAssured = $scope.currentPerson.assured[a];
                if ($scope.currentPerson.type === 'CHILD') {
                    $scope.assuredTypeChanged(currentAssured);
                }
                if (currentAssured.sameAddress && currentAssured.type !== 'ORGANIZATION') {
                    if ($scope.currentPerson.person.address) {
                        currentAssured.city = $scope.currentPerson.person.address.city;
                        currentAssured.street = $scope.currentPerson.person.address.street;
                        currentAssured.number = $scope.currentPerson.person.address.number;
                        currentAssured.apartment = $scope.currentPerson.person.address.apartment;
                        currentAssured.zipCode = $scope.currentPerson.person.address.zipCode;
                    }
                }
            }
        }, true);

    }
})();
